export const sidebarTranslations = {
  ru: {
    groups: {
      main: "Основное",
      community: "Комьюнити",
      info: "Инфо"
    },
    items: {
      home: "Главная",
      stats: "Статистика",
      map: "Карта мира",
      clans: "Кланы",
      friends: "Друзья",
      shop: "Магазин",
      wiki: "Wiki",
      support: "Поддержка",
      rules: "Правила"
    },
    badges: {
      sale: "SALE"
    },
    login: "Войти"
  },
  en: {
    groups: {
      main: "Main",
      community: "Community",
      info: "Info"
    },
    items: {
      home: "Home",
      stats: "Statistics",
      map: "World Map",
      clans: "Clans",
      friends: "Friends",
      shop: "Store",
      wiki: "Wiki",
      support: "Support",
      rules: "Rules"
    },
    badges: {
      sale: "SALE"
    },
    login: "Log in"
  }
};